/**
 * FASWORLD hero — autoplay + manual controls (arrows, dots, swipe)
 */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initHero = (root) => {
    if (!root || root.dataset.fwHeroReady === 'true') return;

    const slides = [...root.querySelectorAll('[data-fw-hero-slide]')];
    const dots = [...root.querySelectorAll('[data-fw-hero-dot]')];
    const prevBtn = root.querySelector('[data-fw-hero-prev]');
    const nextBtn = root.querySelector('[data-fw-hero-next]');
    if (slides.length < 2) return;

    root.dataset.fwHeroReady = 'true';

    const autoplayEnabled = root.dataset.autoplay === 'true' && !reduceMotion.matches;
    const speed = Math.max(2000, Number(root.dataset.autoplaySpeed || 5) * 1000);
    let index = 0;
    let timer = null;
    let touchStartX = 0;
    let touchDeltaX = 0;

    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const stop = () => {
      if (timer) window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      if (!autoplayEnabled || document.hidden) return;
      stop();
      timer = window.setInterval(() => show(index + 1), speed);
    };

    const go = (next) => {
      show(next);
      start();
    };

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => go(i));
    });

    prevBtn?.addEventListener('click', () => go(index - 1));
    nextBtn?.addEventListener('click', () => go(index + 1));

    const viewport = root.querySelector('.fw-hero__viewport') || root;

    viewport.addEventListener(
      'touchstart',
      (event) => {
        if (!event.changedTouches?.[0]) return;
        touchStartX = event.changedTouches[0].clientX;
        touchDeltaX = 0;
        stop();
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchmove',
      (event) => {
        if (!event.changedTouches?.[0]) return;
        touchDeltaX = event.changedTouches[0].clientX - touchStartX;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchend',
      () => {
        if (Math.abs(touchDeltaX) > 40) {
          go(touchDeltaX < 0 ? index + 1 : index - 1);
        } else {
          start();
        }
        touchDeltaX = 0;
      },
      { passive: true }
    );

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) start();
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    reduceMotion.addEventListener?.('change', () => {
      if (reduceMotion.matches) stop();
      else start();
    });

    show(0);
    start();
  };

  const boot = (root = document) => {
    root.querySelectorAll('[data-fw-hero]').forEach(initHero);
  };

  if (!window.__fwHeroListeners) {
    window.__fwHeroListeners = true;
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', (event) => {
      boot(event.target);
    });
  } else if (document.readyState !== 'loading') {
    boot();
  }
})();
